import { useState } from "react";
import { arvoresProximas } from "@/mocks/coletor";

interface QrCodeScannerMockProps {
  onClose: () => void;
}

export default function QrCodeScannerMock({ onClose }: QrCodeScannerMockProps) {
  const [codigo, setCodigo] = useState("");
  const [resultado, setResultado] = useState<typeof arvoresProximas[0] | null>(null);
  const [escaneando, setEscaneando] = useState(false);

  const buscarPorCodigo = () => {
    const encontrada = arvoresProximas.find((a) =>
      a.id.toLowerCase().includes(codigo.toLowerCase())
    );
    if (encontrada) {
      setResultado(encontrada);
    } else if (codigo.length > 3) {
      setResultado(null);
    }
  };

  return (
    <div className="px-4 pt-4 pb-20 max-w-lg mx-auto">
      <div className="flex items-center gap-2 mb-5">
        <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-[#E8EAED] flex items-center justify-center">
          <i className="ri-arrow-left-line text-[#3F4A52] text-lg" />
        </button>
        <h2 className="text-lg font-heading font-bold text-[#3F4A52]">QR Code / Código CTA</h2>
      </div>

      {/* Scanner mock */}
      <div className="bg-[#E8EAED]/50 rounded-xl border border-[#E8EAED] h-52 flex items-center justify-center mb-4 relative overflow-hidden">
        <div className="text-center">
          <i className="ri-qr-scan-line text-5xl text-[#3F4A52]/30" />
          <p className="text-sm text-[#3F4A52]/40 mt-2">Aponte a câmera para o QR Code da árvore</p>
        </div>
        {escaneando && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 border-2 border-[#1B6E4F] rounded-lg animate-pulse" />
          </div>
        )}
        <button
          onClick={() => {
            setEscaneando(true);
            setTimeout(() => {
              setEscaneando(false);
              setCodigo("CTA-GO-5208707-00426");
              buscarPorCodigo();
            }, 2000);
          }}
          className="absolute bottom-3 left-1/2 -translate-x-1/2 px-4 py-2 rounded-full bg-[#1B6E4F] text-white text-xs font-heading font-bold"
        >
          Simular leitura
        </button>
      </div>

      {/* Busca manual */}
      <div className="mb-4">
        <label className="block text-xs font-medium text-[#3F4A52] mb-1.5">Ou digite o código CTA</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            placeholder="CTA-GO-5208707-XXXXX"
            className="flex-1 px-3 py-2.5 rounded-xl border border-[#E8EAED] text-sm font-mono focus:outline-none focus:border-[#1B6E4F]"
          />
          <button onClick={buscarPorCodigo} className="px-4 py-2.5 rounded-xl bg-[#1B6E4F] text-white font-heading font-bold text-sm">
            <i className="ri-search-line" />
          </button>
        </div>
      </div>

      {/* Resultado */}
      {resultado !== null ? (
        resultado ? (
          <div className="bg-white border border-[#E8EAED] rounded-xl overflow-hidden">
            <div className="h-40 bg-[#E8EAED] flex items-center justify-center overflow-hidden">
              <img src={resultado.foto} alt={resultado.especie} className="w-full h-full object-cover" />
            </div>
            <div className="p-4 space-y-3">
              <div className="flex items-center justify-between">
                <p className="text-lg font-heading font-bold text-[#3F4A52]">{resultado.especie}</p>
                {resultado.risco === "Crítico" ? (
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-[#FFEBEE] text-[#D32F2F]">{resultado.risco}</span>
                ) : resultado.risco === "Alto" ? (
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-[#FFF3E0] text-[#F57C00]">{resultado.risco}</span>
                ) : (
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-[#CAF0D3] text-[#1B6E4F]">{resultado.risco}</span>
                )}
              </div>
              <p className="text-xs font-mono text-[#0052CC]">{resultado.id}</p>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <div><span className="text-[#3F4A52]/60">Bairro:</span> <span className="font-medium text-[#3F4A52]">{resultado.bairro}</span></div>
                <div><span className="text-[#3F4A52]/60">Fitossanidade:</span> <span className="font-medium text-[#3F4A52]">{resultado.fitossanitario}</span></div>
                <div>
                  <span className="text-[#3F4A52]/60">Coordenadas:</span>
                  <span className="font-mono text-xs ml-1">{resultado.latitude}, {resultado.longitude}</span>
                </div>
              </div>
              <div className="flex gap-2 pt-2">
                <button className="flex-1 py-3 rounded-xl bg-[#0052CC] text-white font-heading font-bold text-sm">Nova vistoria</button>
                <button className="flex-1 py-3 rounded-xl border border-[#E8EAED] text-sm font-medium text-[#3F4A52]">Adicionar foto</button>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-10 bg-white border border-[#E8EAED] rounded-xl">
            <i className="ri-search-line text-4xl text-[#3F4A52]/20" />
            <p className="text-sm text-[#3F4A52]/40 mt-2">Árvore não encontrada</p>
            <p className="text-xs text-[#3F4A52]/30 mt-1">Verifique o código e tente novamente</p>
          </div>
        )
      ) : null}
    </div>
  );
}